import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9bab9dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "visual_figure" }
const _hoisted_3 = { class: "word" }
const _hoisted_4 = { class: "wrong_letter" }
const _hoisted_5 = { key: 0 }

import VisualGame from '../components/VisualGame.vue'
import WordBlockGame from '../components/WordBlockGame.vue'
import WrongLetterBlockGame from '../components/WrongLetterBlockGame.vue'
import WarningDouble from '../components/WarningDouble.vue'
import EndGameModal from '../modals/EndGameModal.vue'


import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeGame',
  props: {
    isLose: {
        type: Boolean,
        required: true,
        default: false
    },
    isWin: {
        type: Boolean,
        required: true,
        default: false
    }
},
  setup(__props) {

const store = useStore();




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(VisualGame)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(WordBlockGame)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(WrongLetterBlockGame)
      ]),
      _createElementVNode("div", null, [
        _createVNode(WarningDouble)
      ])
    ]),
    (_unref(store).getters.getLetterArray.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(EndGameModal, {
            isWin: __props.isWin,
            isLose: __props.isLose
          }, null, 8, ["isWin", "isLose"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})